import communicationInit, {
  iCommunicationModuleConfig,
} from '../../shared/communication-module'
import i18nInit, {
  changeLanguage,
  iEnvironmentFile,
  iLanguage,
  iRequestLang,
  pluginLocalStorage,
} from '../../shared/i18n-module'
import { getCookieByName, getHashParam } from '../../shared/utils'
import authInit, {
  iAuthProcessApi,
  iValidate,
  iValidateResponse,
} from '../auth'
import {
  COMMUNICATION_CONFIG_AUTH,
  COMUNNICATION_CONFIG_LANGUAGE,
  ENDPOINTS_CONFIG_FILE_NAME,
  ENVIRONMENT_FILE_NAME,
} from './constants'
import { getStaticJson } from './get-static-json'
import { ENVIRONMENTS, iMediatorApi, iMediatorConfig } from './types'

export type iMediator = (
  arqConfig: iMediatorConfig,
) => Promise<iMediatorApi>
const init: iMediator = async (arqConfig) => {
  let environment
  // environment config
  try {
    // obtengo el entorno si es que existe el fichero
    const { env } = await getStaticJson<iEnvironmentFile>(
      `//${location.host}/${ENVIRONMENT_FILE_NAME}`,
    )
    environment = env

    // se obtiene el archivo de configuración de endpoints para el entorno
    const endpointsObj =
      await getStaticJson<iCommunicationModuleConfig>(
        `//${location.host}/${ENDPOINTS_CONFIG_FILE_NAME[environment]}`,
      )

    arqConfig.communicationConfig = endpointsObj
  } catch (e) {
    console.log(e)
    // Si no se ha pódido obtener el archivo de entorno, suponemos que
    // estamos en entorno "LOCAL" y se usa la configuración de arqConfig que se
    // le ha pasado desde la aplicación
    environment = ENVIRONMENTS.LOCAL
  }

  const { call, api } = await communicationInit(
    arqConfig.communicationConfig,
  )

  /* Selección del idioma de la aplicación, se hace aqui antes que la
    autenticación pq como parte de esta se borran los parametros de la
    URl por seguridad */
  const LANG_PARAM_NAME = 'lang'

  const hashParam = getHashParam(LANG_PARAM_NAME)
  const langCookieParam = getCookieByName(LANG_PARAM_NAME)
  const i18nStore = pluginLocalStorage()
  const langUserSelectedParam = i18nStore.get()

  /*
    Para elegir el idioma inicial puede ser (ordenado por prioridad) que:
      1. Haya venido como Hash despues de autenticarse (sms)
      2. Venga en una cookie si venimos desde keycloak
      3. El usuario haya seleccionado previamente un idioma en la
          aplicación (localStorage)
      4. Se indique idioma inicial como parametro de configuración
        i18nConfig.initialLanguage
  */
  const initialLanguage =
    hashParam ||
    langCookieParam ||
    langUserSelectedParam ||
    arqConfig.i18nConfig.initialLanguage ||
    null

  if (initialLanguage !== null) i18nStore.put(initialLanguage)

  // auth module initialization
  const validateRequest: iValidate = async (hash) => {
    if (call.api.auth?.post === undefined)
      throw new Error(COMMUNICATION_CONFIG_AUTH)

    const { data } = await call.api.auth.post<iValidateResponse, any>(
      { hash },
    )
    return data
  }

  let authProcessResult = {
    isAuthenticated: false,
  } as iAuthProcessApi

  const { authProcess } = await authInit({ validateRequest })

  if (arqConfig.authConfig.enableAuth) {
    authProcessResult = await authProcess()
  }

  // i18n-module initialization
  const getLanguage: iRequestLang = async (lang: string) => {
    if (call.api.language?.get === undefined)
      throw new Error(COMUNNICATION_CONFIG_LANGUAGE)

    const { data } = await call.api.language.get<iLanguage, any>({
      lang,
    })
    return data
  }

  const i18nApi = await i18nInit({
    ...arqConfig.i18nConfig,
    requestLang: getLanguage,
    ...(initialLanguage !== null ? { initialLanguage } : undefined),
    store: i18nStore,
  })

  const mediatorApi = {
    i18n: {
      ...i18nApi,
      changeLanguage,
    },
    call,
    api,
    auth: {
      authProcess,
      auth: authProcessResult,
    },
    env: environment,
  }

  return mediatorApi
}

export default init
